import { GlobeIcon, DeviceMobileIcon } from '@phosphor-icons/react';
import { CapacityMeter } from '@/components/ui/capacity-meter';
import type { ChannelVerdict, Matrix } from './types';
import { BAR_MAX_MB } from './feChannelConfig';
import { useAnimatedNumber } from './useAnimatedNumber';
import type { IconType } from './channelIcons';
import { sizeMarks } from './sizeMarks';

function SnapGhost({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      <path d="M12 3c-3 0-5.5 2-5.5 5v2.5c0 .5-.1 1-.4 1.5l-1.4 2.6c-.2.4.1.9.5.9l1.5.1c.3 0 .6.2.8.5l.7 1.2c.3.5.9.7 1.4.4l1.2-.6c.4-.2.8-.2 1.2 0l1.2.6c.5.3 1.1.1 1.4-.4l.7-1.2c.2-.3.5-.5.8-.5l1.5-.1c.4 0 .7-.5.5-.9l-1.4-2.6c-.3-.5-.4-1-.4-1.5V8c0-3-2.5-5-5.5-5z" />
    </svg>
  );
}

export function ChannelIcon({ type, className }: { type: IconType; className?: string }) {
  if (type === 'globe') return <GlobeIcon className={className} />;
  if (type === 'phone') return <DeviceMobileIcon className={className} />;
  return <SnapGhost className={className} />;
}

/** The story's size against each platform's limit, as the health panel's scale. */
export function SizeScale({ matrix, totalMB, verdicts }: { matrix: Matrix; totalMB: number; verdicts: ChannelVerdict[] }) {
  const shown = useAnimatedNumber(Math.min(totalMB / BAR_MAX_MB, 1), 350);
  return <CapacityMeter layout="scale" value={shown} label="Story size" marks={sizeMarks(matrix, verdicts)} />;
}
